var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from "react";
import { Row } from "react-bootstrap";
import InputField from "@frameworks/web/components/generic/inputField";
import DatePicker from "react-datepicker";
export var AddExpenses = function () {
    var _calendar = useRef(null);
    var showDatePicker = function (e) {
        if (_calendar.current) {
            _calendar.current.setOpen(true);
        }
    };
    var _a = __read(useState(new Date()), 2), startDate = _a[0], setStartDate = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "leadlog-main-block" },
            React.createElement(Row, { className: "mx-0 profile-expenses-row" },
                React.createElement("div", null,
                    React.createElement("label", null, "Date")),
                React.createElement("div", { className: "px-0" },
                    React.createElement("div", { className: "col leadpage-selectdropdown leadpage-calendar pdl-0" },
                        React.createElement("div", { className: "inputFieldCalendarIcon input-group yearDropdown singleDatePicker holdingReportsDate leadpage-calendar-input" },
                            React.createElement(DatePicker, { ref: _calendar, selected: startDate, onChange: function (date) { return setStartDate(date); }, showYearDropdown: true, showMonthDropdown: true, dateFormat: "d-MMM-yy", placeholderText: "dd-mm-yy" }),
                            React.createElement("span", { className: "input-group-text" },
                                React.createElement("i", { className: "edel-icon-calendar-report", onClick: showDatePicker })))))),
            React.createElement(Row, { className: "mx-0 profile-expenses-row" },
                React.createElement("div", null,
                    React.createElement("label", null, "Particular")),
                React.createElement(InputField, { type: "text", id: "particular", name: "particular", required: true, autoComplete: "off", placeholderClassName: "" })),
            React.createElement(Row, { className: "mx-0 profile-expenses-row" },
                React.createElement("div", null,
                    React.createElement("label", null, "Mode")),
                React.createElement(InputField, { type: "text", id: "mode", name: "mode", required: true, autoComplete: "off", placeholderClassName: "" })),
            React.createElement(Row, { className: "mx-0 profile-expenses-row" },
                React.createElement("div", null,
                    React.createElement("label", null, "Amount")),
                React.createElement(InputField, { type: "text", id: "amount", name: "amount", required: true, autoComplete: "off", placeholderClassName: "" })))));
};
